export const PDD_SERVICEMARKET_SETTLEMENTBILL_GET = 'pdd.servicemarket.settlementbill.get';
export const PDD_SERVICEMARKET_SETTLEMENTBILL_GET_RESPONSE_KEY = 'settlement_bill_search_response';

/**
 * 接口名称：月结算账单导出
 * 接口标识：pdd.servicemarket.settlementbill.get
 * 接口使用场景：用于ISV查询自己名下的服务的月度结算明细
 **/
export interface PddServicemarketSettlementbillGetRequestInterface {
  /**
   * @description: 分页页码，最大不能超过1000
   * @type: number
   * @default:
   **/
  page: number;

  /**
   * @description: 分页大小，最大不能超过100
   * @type: number
   * @default:
   **/
  page_size: number;

  /**
   * @description: 服务订单号
   * @type: string
   * @default:
   **/
  service_order_sn?: string;

  /**
   * @description: 结算月份
   * @type: string
   * @default:
   **/
  settle_month: string;
}

/**
 * 接口名称：月结算账单导出
 * 接口标识：pdd.servicemarket.settlementbill.get
 * 接口使用场景：用于ISV查询自己名下的服务的月度结算明细
 **/
export interface PddServicemarketSettlementbillGetResponseInterface {
  /**
   * @description: response
   * @type: PddServicemarketSettlementbillGetSettlementBillSearchResponseResponseInterface
   * @default:
   *
   **/
  settlement_bill_search_response: PddServicemarketSettlementbillGetSettlementBillSearchResponseResponseInterface;
}

/**
 * @description response
 * @default
 * @example
 **/
export interface PddServicemarketSettlementbillGetSettlementBillSearchResponseResponseInterface {
  /**
   * @description: 结算明细列表
   * @type: PddServicemarketSettlementbillGetSettlementBillSearchResponseDataResponseInterface[]
   * @default:
   *
   **/
  data: PddServicemarketSettlementbillGetSettlementBillSearchResponseDataResponseInterface[];

  /**
   * @description: 当前查询条件下所有订单总数
   * @type: number
   * @default:
   **/
  total_count: number;
}

/**
 * @description 结算明细列表
 * @default
 * @example
 **/
export interface PddServicemarketSettlementbillGetSettlementBillSearchResponseDataResponseInterface {
  /**
   * @description: 服务订单号
   * @type: string
   * @default:
   **/
  service_order_sn: string;

  /**
   * @description: 当期结算金额，单位分
   * @type: string | number
   * @default:
   **/
  settle_amount: string | number;

  /**
   * @description: 结算月份
   * @type: string
   * @default:
   **/
  settle_month: string;

  /**
   * @description: 结算时间
   * @type: string
   * @default:
   **/
  settle_time: string;

  /**
   * @description: 待结算金额，单位分
   * @type: string | number
   * @default:
   **/
  unsettle_amount: string | number;

  /**
   * @description: 服务名称
   * @type: string
   * @default:
   **/
  service_name: string;

  /**
   * @description: 订单类型：0-应用服务、1-客服外包、2-电子发票、3-店铺装修、4-推广托管、5-代运营服务
   * @type: number
   * @default:
   **/
  order_type: number;
}
